// extracted by mini-css-extract-plugin
export default {"container":"header_content-module__container--1WCu4"};